import React, {Component} from 'react';
import CompletedItem from './CompletedItem.js';


export default class CompletedOrders extends Component{
    constructor(props){
        super(props);

        this.state = {};
    }

    render(){
        if(this.props.orders.length > 0){
            console.log(this.props.orders);
            let rowStyle = {width: '100%'};
            return(

                <div className="completed-orders">
                    <div style={rowStyle} className="row">
                    <table className="top-row">
                            <tr>
                                <td>Created</td>
                                <td>Customer</td>
                                <td>Total Price</td>
                                <td>Status</td>
                                <td>Order ID</td>
                                <td></td>
                            </tr>

                    </table>
                            {this.props.orders.map((order, index) => (
                                   <CompletedItem key={index} order={order} restaurantName={this.props.restaurantName} />
                                )
                            )}

                    </div>
                </div>
            )
        }else {
            return (
                <div>There are no completed orders</div>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Dashboard/CompletedOrders.js